var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoboticsDashboard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-349"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-349",
    cx: 251.22,
    cy: 365.22,
    rx: 218.93,
    ry: 106.7,
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-349"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-349",
    cx: 144.07,
    cy: 373.24,
    rx: 82.26,
    ry: 47.49,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-349",
    cx: 366.1,
    cy: 373.24,
    rx: 82.26,
    ry: 47.49,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-349"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-349"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407.23,367.36c-.71-8.14,2-38.56,9.52-49.87s19.42-23.5,29.14-21.1c9.05,2.23,9.11,13.84-.88,22.42S419.83,338.39,416.3,352l-8.8,23Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.23,367.36c-.71-8.14,2-38.56,9.52-49.87s19.42-23.5,29.14-21.1c9.05,2.23,9.11,13.84-.88,22.42S419.83,338.39,416.3,352l-8.8,23Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.09,363.69a.61.61,0,0,0,.5-.53c3-28.27,23.5-52.83,36.52-59a.59.59,0,1,0-.51-1.07c-13.26,6.29-34.15,31.26-37.2,60a.59.59,0,0,0,.53.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.92,379.65c.9-4.69,4.68-12.66,12.62-20.31,9.73-9.36,25.26-13.92,27.71-19.55,2.94-6.76-2.59-11.81-12.66-9.23-13.54,3.46-29.32,19.21-30.35,40.57Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.51,375a.58.58,0,0,0,.47-.43c6.44-24.56,27.26-36.8,35.58-38.63a.6.6,0,0,0,.45-.71.58.58,0,0,0-.71-.45c-9.2,2-29.91,14.42-36.47,39.48a.59.59,0,0,0,.42.73A.57.57,0,0,0,408.51,375Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-349"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.42,349c.71-8.14-4.13-25.85-11.65-37.16s-18.12-23.76-27.84-21.36c-9.05,2.23-9.12,13.84.88,22.42s25.17,19.58,28.7,33.2l8.81,23Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.72,357.81a.61.61,0,0,1-.49-.53c-3-28.27-23.51-52.83-36.53-59a.59.59,0,0,1-.28-.79.58.58,0,0,1,.79-.28c13.27,6.29,34.15,31.26,37.21,60a.6.6,0,0,1-.53.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.9,373.77c-.91-4.69-4.68-12.66-12.63-20.31C78.54,344.1,63,339.54,60.56,333.91c-2.93-6.76,2.6-11.81,12.67-9.23,13.53,3.46,29.31,19.21,30.35,40.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.31,369.14a.58.58,0,0,1-.48-.43c-6.43-24.56-27.25-36.79-35.57-38.63a.6.6,0,0,1-.46-.71.58.58,0,0,1,.71-.45c9.2,2,29.91,14.42,36.48,39.48a.6.6,0,0,1-.43.73A.53.53,0,0,1,103.31,369.14Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-349"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--gears--inject-349"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.33,75.13h0a.41.41,0,0,0-.42,0l-.88.58-.19.52a1,1,0,0,0,.23,1,3.72,3.72,0,0,1,.4.49.59.59,0,0,0,.82.18l2-1.34a.39.39,0,0,1,.42,0Zm-3.14,7.5a2.49,2.49,0,0,0-2.71-2.37,4,4,0,0,1,.28,1c.45,2.62-1.21,6.34-3.71,8.3a4.94,4.94,0,0,1-2.61,1.17c.81,1.76,2.89,1.93,5,.23C101,89,102.64,85.25,102.19,82.63Zm0-11.21h0a.44.44,0,0,0-.16-.06L100.53,71a.84.84,0,0,0-.87.4l-1.45,2.76a1.11,1.11,0,0,1-.32.37h0a1.38,1.38,0,0,1-.25.17l.45,1.5a.52.52,0,0,0,.73.33,7.5,7.5,0,0,1,1-.31,1.64,1.64,0,0,0,.54-.28,1.18,1.18,0,0,0,.33-.38l1.45-2.76a.84.84,0,0,1,.87-.4l1.54.35.15,0ZM97.9,98.12a.45.45,0,0,1-.15-.24l-.52-1.73a.52.52,0,0,0-.72-.33,6.18,6.18,0,0,1-1,.31,1.3,1.3,0,0,0-.3.13l.07.22a.44.44,0,0,0,.2.27h0ZM95,72.81a.47.47,0,0,0-.17,0,.42.42,0,0,0-.28.11l-2.31,1.81a.76.76,0,0,0-.09.09l-.06.06a1.46,1.46,0,0,0-.2.37l0,.09h0a1,1,0,0,0-.06.37l.14,2.19a1.74,1.74,0,0,1-.36,1.06c-.38.46-.73.93-1.07,1.42a1.13,1.13,0,0,1-.51.39.76.76,0,0,1-.2.06l-.1,0h-.13L88,80.74h-.16l-.11,0h0l-.12,0a1.07,1.07,0,0,0-.21.13.9.9,0,0,0-.24.31L85.8,84.39a.59.59,0,0,0,.23.75l1.65,1a.71.71,0,0,1,0,.43A13.24,13.24,0,0,0,87.46,88a1.86,1.86,0,0,1-.5,1l0,0-2,1.85-.09.11v0a.42.42,0,0,0-.09.14,1.23,1.23,0,0,0-.15.74L85,94.13a.42.42,0,0,0,.18.3l2.41,1.39a.44.44,0,0,1-.17-.29L87,93.3a1.21,1.21,0,0,1,.34-1l2-1.85,0,0a1.86,1.86,0,0,0,.5-1c.06-.49.15-1,.26-1.49a.73.73,0,0,0-.41-.83l-1.2-.51a.61.61,0,0,1-.31-.79l1.39-3.12a1,1,0,0,1,.24-.31,1,1,0,0,1,.62-.22l1.48.08a1.11,1.11,0,0,0,.43-.09,1.25,1.25,0,0,0,.51-.39c.33-.49.69-1,1.07-1.42a1.73,1.73,0,0,0,.35-1.06l-.13-2.19a1,1,0,0,1,0-.38,1.28,1.28,0,0,1,.39-.6l2.3-1.81a.41.41,0,0,1,.46-.07ZM91.49,96.09a1,1,0,0,0-.24-1,3.88,3.88,0,0,1-.4-.49.6.6,0,0,0-.82-.18l-1.16.76L88,97.51a.5.5,0,0,0,.21.62h0l2.44,1.4a.52.52,0,0,1-.21-.63Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.33,75.13h0a.41.41,0,0,0-.42,0l-.88.58-.19.52a1,1,0,0,0,.23,1,3.72,3.72,0,0,1,.4.49.59.59,0,0,0,.82.18l2-1.34a.39.39,0,0,1,.42,0Zm-3.14,7.5a2.49,2.49,0,0,0-2.71-2.37,4,4,0,0,1,.28,1c.45,2.62-1.21,6.34-3.71,8.3a4.94,4.94,0,0,1-2.61,1.17c.81,1.76,2.89,1.93,5,.23C101,89,102.64,85.25,102.19,82.63Zm0-11.21h0a.44.44,0,0,0-.16-.06L100.53,71a.84.84,0,0,0-.87.4l-1.45,2.76a1.11,1.11,0,0,1-.32.37h0a1.38,1.38,0,0,1-.25.17l.45,1.5a.52.52,0,0,0,.73.33,7.5,7.5,0,0,1,1-.31,1.64,1.64,0,0,0,.54-.28,1.18,1.18,0,0,0,.33-.38l1.45-2.76a.84.84,0,0,1,.87-.4l1.54.35.15,0ZM97.9,98.12a.45.45,0,0,1-.15-.24l-.52-1.73a.52.52,0,0,0-.72-.33,6.18,6.18,0,0,1-1,.31,1.3,1.3,0,0,0-.3.13l.07.22a.44.44,0,0,0,.2.27h0ZM95,72.81a.47.47,0,0,0-.17,0,.42.42,0,0,0-.28.11l-2.31,1.81a.76.76,0,0,0-.09.09l-.06.06a1.46,1.46,0,0,0-.2.37l0,.09h0a1,1,0,0,0-.06.37l.14,2.19a1.74,1.74,0,0,1-.36,1.06c-.38.46-.73.93-1.07,1.42a1.13,1.13,0,0,1-.51.39.76.76,0,0,1-.2.06l-.1,0h-.13L88,80.74h-.16l-.11,0h0l-.12,0a1.07,1.07,0,0,0-.21.13.9.9,0,0,0-.24.31L85.8,84.39a.59.59,0,0,0,.23.75l1.65,1a.71.71,0,0,1,0,.43A13.24,13.24,0,0,0,87.46,88a1.86,1.86,0,0,1-.5,1l0,0-2,1.85-.09.11v0a.42.42,0,0,0-.09.14,1.23,1.23,0,0,0-.15.74L85,94.13a.42.42,0,0,0,.18.3l2.41,1.39a.44.44,0,0,1-.17-.29L87,93.3a1.21,1.21,0,0,1,.34-1l2-1.85,0,0a1.86,1.86,0,0,0,.5-1c.06-.49.15-1,.26-1.49a.73.73,0,0,0-.41-.83l-1.2-.51a.61.61,0,0,1-.31-.79l1.39-3.12a1,1,0,0,1,.24-.31,1,1,0,0,1,.62-.22l1.48.08a1.11,1.11,0,0,0,.43-.09,1.25,1.25,0,0,0,.51-.39c.33-.49.69-1,1.07-1.42a1.73,1.73,0,0,0,.35-1.06l-.13-2.19a1,1,0,0,1,0-.38,1.28,1.28,0,0,1,.39-.6l2.3-1.81a.41.41,0,0,1,.46-.07ZM91.49,96.09a1,1,0,0,0-.24-1,3.88,3.88,0,0,1-.4-.49.6.6,0,0,0-.82-.18l-1.16.76L88,97.51a.5.5,0,0,0,.21.62h0l2.44,1.4a.52.52,0,0,1-.21-.63Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.33,75.13h0a.41.41,0,0,0-.42,0l-.88.58-.19.52a1,1,0,0,0,.23,1,3.72,3.72,0,0,1,.4.49.59.59,0,0,0,.82.18l2-1.34a.39.39,0,0,1,.42,0Zm-3.14,7.5a2.49,2.49,0,0,0-2.71-2.37,4,4,0,0,1,.28,1c.45,2.62-1.21,6.34-3.71,8.3a4.94,4.94,0,0,1-2.61,1.17c.81,1.76,2.89,1.93,5,.23C101,89,102.64,85.25,102.19,82.63Zm0-11.21h0a.44.44,0,0,0-.16-.06L100.53,71a.84.84,0,0,0-.87.4l-1.45,2.76a1.11,1.11,0,0,1-.32.37h0a1.38,1.38,0,0,1-.25.17l.45,1.5a.52.52,0,0,0,.73.33,7.5,7.5,0,0,1,1-.31,1.64,1.64,0,0,0,.54-.28,1.18,1.18,0,0,0,.33-.38l1.45-2.76a.84.84,0,0,1,.87-.4l1.54.35.15,0ZM97.9,98.12a.45.45,0,0,1-.15-.24l-.52-1.73a.52.52,0,0,0-.72-.33,6.18,6.18,0,0,1-1,.31,1.3,1.3,0,0,0-.3.13l.07.22a.44.44,0,0,0,.2.27h0ZM95,72.81a.47.47,0,0,0-.17,0,.42.42,0,0,0-.28.11l-2.31,1.81a.76.76,0,0,0-.09.09l-.06.06a1.46,1.46,0,0,0-.2.37l0,.09h0a1,1,0,0,0-.06.37l.14,2.19a1.74,1.74,0,0,1-.36,1.06c-.38.46-.73.93-1.07,1.42a1.13,1.13,0,0,1-.51.39.76.76,0,0,1-.2.06l-.1,0h-.13L88,80.74h-.16l-.11,0h0l-.12,0a1.07,1.07,0,0,0-.21.13.9.9,0,0,0-.24.31L85.8,84.39a.59.59,0,0,0,.23.75l1.65,1a.71.71,0,0,1,0,.43A13.24,13.24,0,0,0,87.46,88a1.86,1.86,0,0,1-.5,1l0,0-2,1.85-.09.11v0a.42.42,0,0,0-.09.14,1.23,1.23,0,0,0-.15.74L85,94.13a.42.42,0,0,0,.18.3l2.41,1.39a.44.44,0,0,1-.17-.29L87,93.3a1.21,1.21,0,0,1,.34-1l2-1.85,0,0a1.86,1.86,0,0,0,.5-1c.06-.49.15-1,.26-1.49a.73.73,0,0,0-.41-.83l-1.2-.51a.61.61,0,0,1-.31-.79l1.39-3.12a1,1,0,0,1,.24-.31,1,1,0,0,1,.62-.22l1.48.08a1.11,1.11,0,0,0,.43-.09,1.25,1.25,0,0,0,.51-.39c.33-.49.69-1,1.07-1.42a1.73,1.73,0,0,0,.35-1.06l-.13-2.19a1,1,0,0,1,0-.38,1.28,1.28,0,0,1,.39-.6l2.3-1.81a.41.41,0,0,1,.46-.07ZM91.49,96.09a1,1,0,0,0-.24-1,3.88,3.88,0,0,1-.4-.49.6.6,0,0,0-.82-.18l-1.16.76L88,97.51a.5.5,0,0,0,.21.62h0l2.44,1.4a.52.52,0,0,1-.21-.63Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.36,90.44l-2,1.85a1.27,1.27,0,0,0-.32.58L84.6,91.48a1.75,1.75,0,0,1,.12-.32.42.42,0,0,1,.09-.14v0l.09-.11,2-1.85Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.38,82.13a1.11,1.11,0,0,1-.43.09l-1.48-.08a1,1,0,0,0-.62.22L87.43,81a1.07,1.07,0,0,1,.21-.13l.12,0h0l.11,0H88l1.48.08h.13l.1,0a1.52,1.52,0,0,0,.2-.06h0Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.75,76.52a.41.41,0,0,0-.42,0l-2,1.35a.59.59,0,0,1-.82-.19,3.17,3.17,0,0,0-.4-.49,1,1,0,0,1-.23-1l.19-.52.88-.58a.39.39,0,0,1,.42,0h0Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.65,72.81l-.15,0L103,72.41a.84.84,0,0,0-.87.4l-1.45,2.76a1.18,1.18,0,0,1-.33.38l-2.42-1.41a1.11,1.11,0,0,0,.32-.37l1.45-2.76a.84.84,0,0,1,.87-.4l1.54.35a.44.44,0,0,1,.16.06h0Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.38,74.21a.41.41,0,0,0-.46.07l-2.3,1.81a1.28,1.28,0,0,0-.39.6L91.81,75.3l0-.09a1.46,1.46,0,0,1,.2-.37l.06-.06a.76.76,0,0,1,.09-.09l2.31-1.81a.42.42,0,0,1,.28-.11.47.47,0,0,1,.17,0Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.36,90.44l-2,1.85a1.27,1.27,0,0,0-.32.58L84.6,91.48a1.75,1.75,0,0,1,.12-.32.42.42,0,0,1,.09-.14v0l.09-.11,2-1.85Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.38,82.13a1.11,1.11,0,0,1-.43.09l-1.48-.08a1,1,0,0,0-.62.22L87.43,81a1.07,1.07,0,0,1,.21-.13l.12,0h0l.11,0H88l1.48.08h.13l.1,0a1.52,1.52,0,0,0,.2-.06h0Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.75,76.52a.41.41,0,0,0-.42,0l-2,1.35a.59.59,0,0,1-.82-.19,3.17,3.17,0,0,0-.4-.49,1,1,0,0,1-.23-1l.19-.52.88-.58a.39.39,0,0,1,.42,0h0Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.65,72.81l-.15,0L103,72.41a.84.84,0,0,0-.87.4l-1.45,2.76a1.18,1.18,0,0,1-.33.38l-2.42-1.41a1.11,1.11,0,0,0,.32-.37l1.45-2.76a.84.84,0,0,1,.87-.4l1.54.35a.44.44,0,0,1,.16.06h0Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.38,74.21a.41.41,0,0,0-.46.07l-2.3,1.81a1.28,1.28,0,0,0-.39.6L91.81,75.3l0-.09a1.46,1.46,0,0,1,.2-.37l.06-.06a.76.76,0,0,1,.09-.09l2.31-1.81a.42.42,0,0,1,.28-.11.47.47,0,0,1,.17,0Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.33,79.06l-.39-2.22a.37.37,0,0,0-.61-.27l-2,1.35a.6.6,0,0,1-.82-.19,4.66,4.66,0,0,0-.39-.49,1,1,0,0,1-.24-1l1-2.81a.52.52,0,0,0-.38-.7L103,72.41a.83.83,0,0,0-.87.41l-1.45,2.75a1.48,1.48,0,0,1-.87.66,7.5,7.5,0,0,0-1,.31.52.52,0,0,1-.73-.33l-.52-1.73a.38.38,0,0,0-.65-.2l-2.3,1.81a1.28,1.28,0,0,0-.44,1l.14,2.19A1.74,1.74,0,0,1,94,80.32c-.38.46-.74.93-1.07,1.42a1.21,1.21,0,0,1-.94.48l-1.48-.08a1,1,0,0,0-.85.53l-1.4,3.12a.61.61,0,0,0,.31.79l1.2.51a.73.73,0,0,1,.41.83c-.11.5-.2,1-.26,1.49a1.85,1.85,0,0,1-.49,1l-2,1.88a1.22,1.22,0,0,0-.34,1l.38,2.23a.37.37,0,0,0,.61.26l2-1.34a.6.6,0,0,1,.82.18,5,5,0,0,0,.4.49,1,1,0,0,1,.24,1l-1,2.82a.51.51,0,0,0,.38.7l1.54.34a.83.83,0,0,0,.87-.4l1.45-2.76a1.51,1.51,0,0,1,.87-.65,8.17,8.17,0,0,0,1-.32.52.52,0,0,1,.72.33l.52,1.73a.39.39,0,0,0,.65.21l2.31-1.82a1.28,1.28,0,0,0,.44-1L101,93.1a1.72,1.72,0,0,1,.36-1.06,17,17,0,0,0,1.07-1.42,1.19,1.19,0,0,1,.94-.47l1.48.07a1,1,0,0,0,.85-.52l1.39-3.12a.59.59,0,0,0-.31-.79l-1.19-.51a.76.76,0,0,1-.42-.83,13.3,13.3,0,0,0,.26-1.49,1.83,1.83,0,0,1,.5-1l2-1.88A1.26,1.26,0,0,0,108.33,79.06ZM98.48,90.93c-2.5,2-4.89,1.43-5.34-1.19s1.21-6.34,3.7-8.31,4.89-1.43,5.35,1.2S101,89,98.48,90.93Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.33,79.06l-.39-2.22a.37.37,0,0,0-.61-.27l-2,1.35a.6.6,0,0,1-.82-.19,4.66,4.66,0,0,0-.39-.49,1,1,0,0,1-.24-1l1-2.81a.52.52,0,0,0-.38-.7L103,72.41a.83.83,0,0,0-.87.41l-1.45,2.75a1.48,1.48,0,0,1-.87.66,7.5,7.5,0,0,0-1,.31.52.52,0,0,1-.73-.33l-.52-1.73a.38.38,0,0,0-.65-.2l-2.3,1.81a1.28,1.28,0,0,0-.44,1l.14,2.19A1.74,1.74,0,0,1,94,80.32c-.38.46-.74.93-1.07,1.42a1.21,1.21,0,0,1-.94.48l-1.48-.08a1,1,0,0,0-.85.53l-1.4,3.12a.61.61,0,0,0,.31.79l1.2.51a.73.73,0,0,1,.41.83c-.11.5-.2,1-.26,1.49a1.85,1.85,0,0,1-.49,1l-2,1.88a1.22,1.22,0,0,0-.34,1l.38,2.23a.37.37,0,0,0,.61.26l2-1.34a.6.6,0,0,1,.82.18,5,5,0,0,0,.4.49,1,1,0,0,1,.24,1l-1,2.82a.51.51,0,0,0,.38.7l1.54.34a.83.83,0,0,0,.87-.4l1.45-2.76a1.51,1.51,0,0,1,.87-.65,8.17,8.17,0,0,0,1-.32.52.52,0,0,1,.72.33l.52,1.73a.39.39,0,0,0,.65.21l2.31-1.82a1.28,1.28,0,0,0,.44-1L101,93.1a1.72,1.72,0,0,1,.36-1.06,17,17,0,0,0,1.07-1.42,1.19,1.19,0,0,1,.94-.47l1.48.07a1,1,0,0,0,.85-.52l1.39-3.12a.59.59,0,0,0-.31-.79l-1.19-.51a.76.76,0,0,1-.42-.83,13.3,13.3,0,0,0,.26-1.49,1.83,1.83,0,0,1,.5-1l2-1.88A1.26,1.26,0,0,0,108.33,79.06ZM98.48,90.93c-2.5,2-4.89,1.43-5.34-1.19s1.21-6.34,3.7-8.31,4.89-1.43,5.35,1.2S101,89,98.48,90.93Z",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.89,52.72h0a.59.59,0,0,0-.63.06l-1.32.87-.29.79A1.5,1.5,0,0,0,84,55.9a6.31,6.31,0,0,1,.6.73.88.88,0,0,0,1.23.27l3.07-2a.61.61,0,0,1,.63-.06ZM81.17,64c-.43-2.49-2-3.73-4.07-3.56a6,6,0,0,1,.42,1.46c.68,3.94-1.82,9.53-5.57,12.49A7.71,7.71,0,0,1,68,76.14c1.23,2.64,4.35,2.89,7.59.34C79.35,73.53,81.85,67.93,81.17,64Zm.07-16.85h0a.75.75,0,0,0-.25-.09l-2.31-.53a1.26,1.26,0,0,0-1.31.61l-2.18,4.15a1.88,1.88,0,0,1-.48.55h0a1.85,1.85,0,0,1-.37.25L75,54.34a.79.79,0,0,0,1.09.5,13.22,13.22,0,0,1,1.43-.47,2.32,2.32,0,0,0,.82-.43,1.68,1.68,0,0,0,.49-.55L81,49.24a1.24,1.24,0,0,1,1.31-.61l2.31.52a.85.85,0,0,1,.24.09ZM74.72,87.28a.63.63,0,0,1-.22-.35l-.78-2.6a.77.77,0,0,0-1.09-.49,10.3,10.3,0,0,1-1.43.46,2.16,2.16,0,0,0-.45.19l.1.34a.75.75,0,0,0,.3.4h0Zm-4.44-38a.43.43,0,0,0-.25-.07.7.7,0,0,0-.43.16l-3.47,2.73-.13.12a.48.48,0,0,0-.09.11,2.35,2.35,0,0,0-.3.54l0,.14h0a1.64,1.64,0,0,0-.09.56l.21,3.3a2.61,2.61,0,0,1-.54,1.59c-.57.68-1.11,1.4-1.61,2.13a1.77,1.77,0,0,1-.77.59,1.71,1.71,0,0,1-.3.09l-.15,0a.65.65,0,0,1-.2,0l-2.22-.11h-.06a.55.55,0,0,0-.18,0,.45.45,0,0,0-.16,0h0l-.18.07a1.45,1.45,0,0,0-.32.2,1.31,1.31,0,0,0-.36.46l-2.1,4.69a.9.9,0,0,0,.36,1.13l2.47,1.43a1.17,1.17,0,0,1,.06.64A19.83,19.83,0,0,0,59,72.08a2.81,2.81,0,0,1-.75,1.52l0,0-3,2.79a.8.8,0,0,0-.15.17l0,0a.67.67,0,0,0-.12.2,1.81,1.81,0,0,0-.23,1.12l.58,3.35a.68.68,0,0,0,.27.45l3.63,2.1a.71.71,0,0,1-.25-.45L58.33,80a1.57,1.57,0,0,1,0-.64,1.69,1.69,0,0,1,.48-.87l3-2.79,0,0a2.84,2.84,0,0,0,.75-1.53,20.64,20.64,0,0,1,.39-2.24,1.12,1.12,0,0,0-.62-1.24l-1.8-.76a.9.9,0,0,1-.47-1.19l2.09-4.7a1.2,1.2,0,0,1,.36-.45,1.37,1.37,0,0,1,.92-.34l2.24.11a1.36,1.36,0,0,0,.64-.13,1.65,1.65,0,0,0,.76-.58c.51-.74,1-1.45,1.61-2.13a2.6,2.6,0,0,0,.54-1.6l-.2-3.29a1.27,1.27,0,0,1,.08-.57,1.86,1.86,0,0,1,.58-.91l3.46-2.72a.61.61,0,0,1,.69-.1Zm-5.2,35a1.52,1.52,0,0,0-.36-1.46,6.07,6.07,0,0,1-.59-.73.89.89,0,0,0-1.24-.28l-1.75,1.15-1.27,3.45a.77.77,0,0,0,.31.94h0l3.66,2.11a.75.75,0,0,1-.31-.94Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.89,52.72h0a.59.59,0,0,0-.63.06l-1.32.87-.29.79A1.5,1.5,0,0,0,84,55.9a6.31,6.31,0,0,1,.6.73.88.88,0,0,0,1.23.27l3.07-2a.61.61,0,0,1,.63-.06ZM81.17,64c-.43-2.49-2-3.73-4.07-3.56a6,6,0,0,1,.42,1.46c.68,3.94-1.82,9.53-5.57,12.49A7.71,7.71,0,0,1,68,76.14c1.23,2.64,4.35,2.89,7.59.34C79.35,73.53,81.85,67.93,81.17,64Zm.07-16.85h0a.75.75,0,0,0-.25-.09l-2.31-.53a1.26,1.26,0,0,0-1.31.61l-2.18,4.15a1.88,1.88,0,0,1-.48.55h0a1.85,1.85,0,0,1-.37.25L75,54.34a.79.79,0,0,0,1.09.5,13.22,13.22,0,0,1,1.43-.47,2.32,2.32,0,0,0,.82-.43,1.68,1.68,0,0,0,.49-.55L81,49.24a1.24,1.24,0,0,1,1.31-.61l2.31.52a.85.85,0,0,1,.24.09ZM74.72,87.28a.63.63,0,0,1-.22-.35l-.78-2.6a.77.77,0,0,0-1.09-.49,10.3,10.3,0,0,1-1.43.46,2.16,2.16,0,0,0-.45.19l.1.34a.75.75,0,0,0,.3.4h0Zm-4.44-38a.43.43,0,0,0-.25-.07.7.7,0,0,0-.43.16l-3.47,2.73-.13.12a.48.48,0,0,0-.09.11,2.35,2.35,0,0,0-.3.54l0,.14h0a1.64,1.64,0,0,0-.09.56l.21,3.3a2.61,2.61,0,0,1-.54,1.59c-.57.68-1.11,1.4-1.61,2.13a1.77,1.77,0,0,1-.77.59,1.71,1.71,0,0,1-.3.09l-.15,0a.65.65,0,0,1-.2,0l-2.22-.11h-.06a.55.55,0,0,0-.18,0,.45.45,0,0,0-.16,0h0l-.18.07a1.45,1.45,0,0,0-.32.2,1.31,1.31,0,0,0-.36.46l-2.1,4.69a.9.9,0,0,0,.36,1.13l2.47,1.43a1.17,1.17,0,0,1,.06.64A19.83,19.83,0,0,0,59,72.08a2.81,2.81,0,0,1-.75,1.52l0,0-3,2.79a.8.8,0,0,0-.15.17l0,0a.67.67,0,0,0-.12.2,1.81,1.81,0,0,0-.23,1.12l.58,3.35a.68.68,0,0,0,.27.45l3.63,2.1a.71.71,0,0,1-.25-.45L58.33,80a1.57,1.57,0,0,1,0-.64,1.69,1.69,0,0,1,.48-.87l3-2.79,0,0a2.84,2.84,0,0,0,.75-1.53,20.64,20.64,0,0,1,.39-2.24,1.12,1.12,0,0,0-.62-1.24l-1.8-.76a.9.9,0,0,1-.47-1.19l2.09-4.7a1.2,1.2,0,0,1,.36-.45,1.37,1.37,0,0,1,.92-.34l2.24.11a1.36,1.36,0,0,0,.64-.13,1.65,1.65,0,0,0,.76-.58c.51-.74,1-1.45,1.61-2.13a2.6,2.6,0,0,0,.54-1.6l-.2-3.29a1.27,1.27,0,0,1,.08-.57,1.86,1.86,0,0,1,.58-.91l3.46-2.72a.61.61,0,0,1,.69-.1Zm-5.2,35a1.52,1.52,0,0,0-.36-1.46,6.07,6.07,0,0,1-.59-.73.89.89,0,0,0-1.24-.28l-1.75,1.15-1.27,3.45a.77.77,0,0,0,.31.94h0l3.66,2.11a.75.75,0,0,1-.31-.94Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.89,52.72h0a.59.59,0,0,0-.63.06l-1.32.87-.29.79A1.5,1.5,0,0,0,84,55.9a6.31,6.31,0,0,1,.6.73.88.88,0,0,0,1.23.27l3.07-2a.61.61,0,0,1,.63-.06ZM81.17,64c-.43-2.49-2-3.73-4.07-3.56a6,6,0,0,1,.42,1.46c.68,3.94-1.82,9.53-5.57,12.49A7.71,7.71,0,0,1,68,76.14c1.23,2.64,4.35,2.89,7.59.34C79.35,73.53,81.85,67.93,81.17,64Zm.07-16.85h0a.75.75,0,0,0-.25-.09l-2.31-.53a1.26,1.26,0,0,0-1.31.61l-2.18,4.15a1.88,1.88,0,0,1-.48.55h0a1.85,1.85,0,0,1-.37.25L75,54.34a.79.79,0,0,0,1.09.5,13.22,13.22,0,0,1,1.43-.47,2.32,2.32,0,0,0,.82-.43,1.68,1.68,0,0,0,.49-.55L81,49.24a1.24,1.24,0,0,1,1.31-.61l2.31.52a.85.85,0,0,1,.24.09ZM74.72,87.28a.63.63,0,0,1-.22-.35l-.78-2.6a.77.77,0,0,0-1.09-.49,10.3,10.3,0,0,1-1.43.46,2.16,2.16,0,0,0-.45.19l.1.34a.75.75,0,0,0,.3.4h0Zm-4.44-38a.43.43,0,0,0-.25-.07.7.7,0,0,0-.43.16l-3.47,2.73-.13.12a.48.48,0,0,0-.09.11,2.35,2.35,0,0,0-.3.54l0,.14h0a1.64,1.64,0,0,0-.09.56l.21,3.3a2.61,2.61,0,0,1-.54,1.59c-.57.68-1.11,1.4-1.61,2.13a1.77,1.77,0,0,1-.77.59,1.71,1.71,0,0,1-.3.09l-.15,0a.65.65,0,0,1-.2,0l-2.22-.11h-.06a.55.55,0,0,0-.18,0,.45.45,0,0,0-.16,0h0l-.18.07a1.45,1.45,0,0,0-.32.2,1.31,1.31,0,0,0-.36.46l-2.1,4.69a.9.9,0,0,0,.36,1.13l2.47,1.43a1.17,1.17,0,0,1,.06.64A19.83,19.83,0,0,0,59,72.08a2.81,2.81,0,0,1-.75,1.52l0,0-3,2.79a.8.8,0,0,0-.15.17l0,0a.67.67,0,0,0-.12.2,1.81,1.81,0,0,0-.23,1.12l.58,3.35a.68.68,0,0,0,.27.45l3.63,2.1a.71.71,0,0,1-.25-.45L58.33,80a1.57,1.57,0,0,1,0-.64,1.69,1.69,0,0,1,.48-.87l3-2.79,0,0a2.84,2.84,0,0,0,.75-1.53,20.64,20.64,0,0,1,.39-2.24,1.12,1.12,0,0,0-.62-1.24l-1.8-.76a.9.9,0,0,1-.47-1.19l2.09-4.7a1.2,1.2,0,0,1,.36-.45,1.37,1.37,0,0,1,.92-.34l2.24.11a1.36,1.36,0,0,0,.64-.13,1.65,1.65,0,0,0,.76-.58c.51-.74,1-1.45,1.61-2.13a2.6,2.6,0,0,0,.54-1.6l-.2-3.29a1.27,1.27,0,0,1,.08-.57,1.86,1.86,0,0,1,.58-.91l3.46-2.72a.61.61,0,0,1,.69-.1Zm-5.2,35a1.52,1.52,0,0,0-.36-1.46,6.07,6.07,0,0,1-.59-.73.89.89,0,0,0-1.24-.28l-1.75,1.15-1.27,3.45a.77.77,0,0,0,.31.94h0l3.66,2.11a.75.75,0,0,1-.31-.94Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.88,75.74l-3,2.79a1.69,1.69,0,0,0-.48.87l-3.64-2.1a2,2,0,0,1,.18-.48.67.67,0,0,1,.12-.2l0,0a.8.8,0,0,1,.15-.17l3-2.79Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.42,63.24a1.36,1.36,0,0,1-.64.13l-2.24-.11a1.37,1.37,0,0,0-.92.34L59,61.49a1.45,1.45,0,0,1,.32-.2l.18-.07h0a.45.45,0,0,1,.16,0,.55.55,0,0,1,.18,0h.06l2.22.11a.65.65,0,0,0,.2,0l.15,0a1.66,1.66,0,0,0,.29-.1h0Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.53,54.81a.6.6,0,0,0-.62.08l-3.07,2a.9.9,0,0,1-1.23-.28,6.25,6.25,0,0,0-.6-.74,1.49,1.49,0,0,1-.36-1.46l.29-.78,1.32-.87a.59.59,0,0,1,.63-.06h0Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.88,49.24a.85.85,0,0,0-.24-.09l-2.31-.52a1.24,1.24,0,0,0-1.31.61l-2.18,4.15a1.68,1.68,0,0,1-.49.55l-3.64-2.11a1.88,1.88,0,0,0,.48-.55l2.18-4.15a1.26,1.26,0,0,1,1.31-.61l2.31.53a.75.75,0,0,1,.25.09h0Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.94,51.34a.61.61,0,0,0-.69.1l-3.46,2.72a1.86,1.86,0,0,0-.58.91L65.56,53l0-.14a2.35,2.35,0,0,1,.3-.54.48.48,0,0,1,.09-.11l.13-.12,3.47-2.73a.7.7,0,0,1,.43-.16.43.43,0,0,1,.25.07Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.88,75.74l-3,2.79a1.69,1.69,0,0,0-.48.87l-3.64-2.1a2,2,0,0,1,.18-.48.67.67,0,0,1,.12-.2l0,0a.8.8,0,0,1,.15-.17l3-2.79Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.42,63.24a1.36,1.36,0,0,1-.64.13l-2.24-.11a1.37,1.37,0,0,0-.92.34L59,61.49a1.45,1.45,0,0,1,.32-.2l.18-.07h0a.45.45,0,0,1,.16,0,.55.55,0,0,1,.18,0h.06l2.22.11a.65.65,0,0,0,.2,0l.15,0a1.66,1.66,0,0,0,.29-.1h0Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.53,54.81a.6.6,0,0,0-.62.08l-3.07,2a.9.9,0,0,1-1.23-.28,6.25,6.25,0,0,0-.6-.74,1.49,1.49,0,0,1-.36-1.46l.29-.78,1.32-.87a.59.59,0,0,1,.63-.06h0Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.88,49.24a.85.85,0,0,0-.24-.09l-2.31-.52a1.24,1.24,0,0,0-1.31.61l-2.18,4.15a1.68,1.68,0,0,1-.49.55l-3.64-2.11a1.88,1.88,0,0,0,.48-.55l2.18-4.15a1.26,1.26,0,0,1,1.31-.61l2.31.53a.75.75,0,0,1,.25.09h0Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.94,51.34a.61.61,0,0,0-.69.1l-3.46,2.72a1.86,1.86,0,0,0-.58.91L65.56,53l0-.14a2.35,2.35,0,0,1,.3-.54.48.48,0,0,1,.09-.11l.13-.12,3.47-2.73a.7.7,0,0,1,.43-.16.43.43,0,0,1,.25.07Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4,58.63l-.58-3.35a.55.55,0,0,0-.91-.39l-3.07,2a.9.9,0,0,1-1.23-.28,6.31,6.31,0,0,0-.6-.73,1.54,1.54,0,0,1-.36-1.47l1.57-4.23a.78.78,0,0,0-.58-1.05l-2.31-.52a1.24,1.24,0,0,0-1.31.61l-2.18,4.14a2.22,2.22,0,0,1-1.31,1,11.79,11.79,0,0,0-1.42.47.79.79,0,0,1-1.1-.5l-.78-2.59a.58.58,0,0,0-1-.31l-3.46,2.72a1.93,1.93,0,0,0-.66,1.47l.2,3.3a2.6,2.6,0,0,1-.54,1.6c-.56.68-1.1,1.39-1.61,2.13a1.77,1.77,0,0,1-1.41.71l-2.22-.11a1.43,1.43,0,0,0-1.28.79l-2.1,4.7a.89.89,0,0,0,.47,1.18l1.8.77a1.12,1.12,0,0,1,.62,1.24,18.47,18.47,0,0,0-.39,2.24,2.84,2.84,0,0,1-.75,1.53l-3.07,2.82A1.88,1.88,0,0,0,58.33,80l.58,3.35a.55.55,0,0,0,.91.4l3.07-2a.89.89,0,0,1,1.23.28,7.29,7.29,0,0,0,.6.73,1.49,1.49,0,0,1,.36,1.46l-1.56,4.23a.77.77,0,0,0,.57,1.06L66.4,90a1.25,1.25,0,0,0,1.31-.6l2.18-4.15a2.33,2.33,0,0,1,1.31-1,9.54,9.54,0,0,0,1.43-.47.78.78,0,0,1,1.09.5l.78,2.6a.58.58,0,0,0,1,.31L79,84.51A2,2,0,0,0,79.61,83l-.21-3.3a2.61,2.61,0,0,1,.54-1.59c.57-.68,1.1-1.39,1.61-2.13A1.79,1.79,0,0,1,83,75.3l2.23.11a1.42,1.42,0,0,0,1.28-.78l2.09-4.7a.89.89,0,0,0-.46-1.19L86.3,68a1.1,1.1,0,0,1-.62-1.24,19.78,19.78,0,0,0,.38-2.24A2.81,2.81,0,0,1,86.81,63l3.08-2.82A1.85,1.85,0,0,0,90.4,58.63ZM75.6,76.48c-3.76,3-7.36,2.15-8-1.79s1.82-9.54,5.58-12.5,7.35-2.15,8,1.8S79.35,73.53,75.6,76.48Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4,58.63l-.58-3.35a.55.55,0,0,0-.91-.39l-3.07,2a.9.9,0,0,1-1.23-.28,6.31,6.31,0,0,0-.6-.73,1.54,1.54,0,0,1-.36-1.47l1.57-4.23a.78.78,0,0,0-.58-1.05l-2.31-.52a1.24,1.24,0,0,0-1.31.61l-2.18,4.14a2.22,2.22,0,0,1-1.31,1,11.79,11.79,0,0,0-1.42.47.79.79,0,0,1-1.1-.5l-.78-2.59a.58.58,0,0,0-1-.31l-3.46,2.72a1.93,1.93,0,0,0-.66,1.47l.2,3.3a2.6,2.6,0,0,1-.54,1.6c-.56.68-1.1,1.39-1.61,2.13a1.77,1.77,0,0,1-1.41.71l-2.22-.11a1.43,1.43,0,0,0-1.28.79l-2.1,4.7a.89.89,0,0,0,.47,1.18l1.8.77a1.12,1.12,0,0,1,.62,1.24,18.47,18.47,0,0,0-.39,2.24,2.84,2.84,0,0,1-.75,1.53l-3.07,2.82A1.88,1.88,0,0,0,58.33,80l.58,3.35a.55.55,0,0,0,.91.4l3.07-2a.89.89,0,0,1,1.23.28,7.29,7.29,0,0,0,.6.73,1.49,1.49,0,0,1,.36,1.46l-1.56,4.23a.77.77,0,0,0,.57,1.06L66.4,90a1.25,1.25,0,0,0,1.31-.6l2.18-4.15a2.33,2.33,0,0,1,1.31-1,9.54,9.54,0,0,0,1.43-.47.78.78,0,0,1,1.09.5l.78,2.6a.58.58,0,0,0,1,.31L79,84.51A2,2,0,0,0,79.61,83l-.21-3.3a2.61,2.61,0,0,1,.54-1.59c.57-.68,1.1-1.39,1.61-2.13A1.79,1.79,0,0,1,83,75.3l2.23.11a1.42,1.42,0,0,0,1.28-.78l2.09-4.7a.89.89,0,0,0-.46-1.19L86.3,68a1.1,1.1,0,0,1-.62-1.24,19.78,19.78,0,0,0,.38-2.24A2.81,2.81,0,0,1,86.81,63l3.08-2.82A1.85,1.85,0,0,0,90.4,58.63ZM75.6,76.48c-3.76,3-7.36,2.15-8-1.79s1.82-9.54,5.58-12.5,7.35-2.15,8,1.8S79.35,73.53,75.6,76.48Z",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Robot--inject-349"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--robot--inject-349"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.11,203.84c1.89,13.91,2.41,58.81,1.82,71.51s-.06,22.62-7,23.78c-2.56.42-8.5.4-9.74-2.34-1.49-3.3-3.83-18.5-5.51-27.42-3.11-16.56-7.3-44.05-7.3-44.05S152.49,206.52,171.11,203.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.59,373.85a5.2,5.2,0,0,1-.33,3.78c-.56,1.09-6.44,4.18-14.22,3.42a32.61,32.61,0,0,1-16-6.11c-2.91-2.06-6-2.52-9.85-2.86s-8.87-2.41-9.66-4.24.27-4.91.27-4.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.31,352.57a9.88,9.88,0,0,1,2.09-.54,5.58,5.58,0,0,1,2.54.14c2.17.72,2.45,3.23,4,4.62a21,21,0,0,0,4.64,3.29c2.51,1.44,3.34,2,5.93,3.23s6.19,2.13,8.24,3.6c3,2.16,3.24,7.35-.3,9.29-3.06,1.68-11,3.36-19.26.76-4.49-1.42-9.36-6.4-15.28-7-3.77-.41-10.87-1.68-13.21-4.62-.77-1.15-.06-3.25.25-4.44.14-.52.29-1.05.44-1.57a3.3,3.3,0,0,1,.43-1.21c.53-.56,1.66-.32,2.31-.21a16,16,0,0,0,6.75.05C162.67,357,165.7,353.91,169.31,352.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.06,378.23c5.5.36,10.2-.83,12.39-2,3-1.62,3.27-5.49,1.56-8-2.62,3.45-6.68,3.19-8.83,4-.88.31-.52,2-.7,3.78C188.33,377.43,186.59,378,184.06,378.23Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,291.54c-5.13-.71-6.21,2.28-6.87,6.37s-6,57.56-6.19,60.38,4.74,5.94,9.71,7,7.79-10.33,12.59-11.77c3.86-1.16,4.08,1.24,6.71,3.31l-7.12-63.5Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.14,283.68c-6.41-.12-8.6,6.55-8.39,10.54s2.51,9.55,8.59,9.06C175.55,302.63,174.55,284.08,167.14,283.68Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.14,283.68c-6.41-.12-8.6,6.55-8.39,10.54s2.51,9.55,8.59,9.06C175.55,302.63,174.55,284.08,167.14,283.68Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.34,309.11l-.14-.05c-3.44-1.05-5.59-2.29-6.91-4.05,0,.43-.09.88-.14,1.34a14.93,14.93,0,0,0,6.76,3.66l.14.05c1.64.49,1.86.56,1.49,7.79-.65,12.66-2.32,26.16-3.23,31.7a2.53,2.53,0,0,1-1,1.82,2.58,2.58,0,0,1-2.1.1c-2.27-.64-5.15-1.72-6.45-2.22,0,.35-.07.69-.1,1,1.41.54,4.11,1.55,6.28,2.16a5.18,5.18,0,0,0,1.34.2,2.84,2.84,0,0,0,1.56-.42,3.47,3.47,0,0,0,1.41-2.5c.91-5.56,2.59-19.11,3.24-31.81C163.91,310.49,163.74,309.84,161.34,309.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.51,212.41c4.53,0,11.8,2.76,16.12,8.35s4,13.72,4,13.72c3.82,1.35,10.84-1.43,14.64-4.92,4.74-4.35,8.57-8.75,11-14.2a35.15,35.15,0,0,0,2.84-8.62,30.07,30.07,0,0,0-.27-9.28c-2-11.3-18.56-12-27.12-12-26.29-.07-26.53,6.11-28.78,13.23-1.9,6-3.15,17.55-.35,18C116.69,214.25,119.37,212.41,123.51,212.41Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.27,194.46c-1,3.23,3.62,13.24,25,13.26,20.49,0,26.1-7.1,25-11.75s-6.19-9.75-24.42-9.75C129.75,186.22,121.28,188.26,119.27,194.46Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.27,176.63a24.62,24.62,0,0,1-10.77-2.07c-10.54-5.23-14.14-13.64-20.68-28.91-1.17-2.76-2.46-5.78-3.93-9.1-2.3-4.65-3.61-6.15-4.09-6.59l-.45.08A6.46,6.46,0,0,1,158,117.35c9.06-1.7,13.81,4,18.56,13.62a2.56,2.56,0,0,1,.11.24c1.52,3.42,2.85,6.53,4.06,9.36C187,155.24,189.25,160,195.23,163c5.73,2.84,25.87-2,33.8-9.35a6.45,6.45,0,0,1,8.77,9.47C229.76,170.55,213.06,176.63,200.27,176.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,145.18h-.24A2,2,0,0,1,241,143a22.82,22.82,0,0,1,1.74-7.27,15,15,0,0,1,5.57-6.24,2,2,0,1,1,2.14,3.35,11.07,11.07,0,0,0-4.07,4.48,18.94,18.94,0,0,0-1.43,6.16A2,2,0,0,1,243,145.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.54,150.37a2,2,0,0,1-.91-.23,2,2,0,0,1-.85-2.67,22.64,22.64,0,0,1,4.17-6.21,15.09,15.09,0,0,1,7.4-3.9,2,2,0,0,1,.83,3.89A11.19,11.19,0,0,0,250.8,144a19,19,0,0,0-3.49,5.27A2,2,0,0,1,245.54,150.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.95,
    cy: 153.02,
    r: 11.08,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.12,151.8a2.13,2.13,0,0,1-.78-.16c-3.47-1.49-4.9-4.93-4.25-10.23a2,2,0,1,1,3.94.49c-.54,4.45.72,5.59,1.87,6.08a2,2,0,0,1-.78,3.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.57,145.38a2,2,0,0,1-1.91-1.43,22.39,22.39,0,0,1-1-7.37,15.1,15.1,0,0,1,2.65-7.92,2,2,0,1,1,3.27,2.25,10.89,10.89,0,0,0-2,5.69,18.44,18.44,0,0,0,.83,6.22,2,2,0,0,1-1.34,2.47A1.87,1.87,0,0,1,237.57,145.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.63,234.48c-1.76,16.58-11.46,59-15.76,63.11s-11.24,4.08-13.24-4.3-.44-68,1-76.56,10-9.93,18.19-6.47S147.2,219.82,143.63,234.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.71,378.13a8.43,8.43,0,0,0,.67,4.7c.71,1.16,2.72,2.29,3.36,4.13s.17,4.17.61,6.26c.39,1.83,1.4,5.56,6.59,8.74s13.47,2.74,18.66,2.09,8.86-2.88,9.22-5.69a13.76,13.76,0,0,0-.89-5.91Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.42,369.05c-.55,4.86-1.16,7.14-.64,9.44s2.89,3.36,4.57,5.86-1.09,8.43,4.84,13.07,11.93,4.88,19.44,4.31c4.29-.32,7-1.59,8.25-2.75,2.65-2.43,2.48-7.4.16-9.72a58.13,58.13,0,0,1-4.18-4.4c-1.31-1.68-2.61-3.26-4.23-5.7-2.93-4.43-3.45-14.88-5.38-17.07S104.39,356,101.42,369.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.93,397.65a17.82,17.82,0,0,0-.25-2.29c-.44-2.82-2-3.54-4.74-3.54s-11.8.39-11.8,3.66c0,5-4.38,5.69-7.24,4.75,4.48,1.9,9.19,1.92,14.73,1.5,4.29-.32,7-1.59,8.25-2.75A4.2,4.2,0,0,0,138.93,397.65Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.63,293.29c-2.75.51-3.32,4.88-4.52,11.94s-10.2,62.82-10,65.81,2.94,7.23,5.24,9.26,5.52.28,7.24-6.08c2.28-8.38,10.5-9.46,12.76-4,3.13,7.5,4.28,9,4.28,9S131.1,361.41,131,342c-.11-13.31-.14-30.68-.14-40.07,0-6-.9-7-2.17-7.43C125.05,293.4,114.63,293.29,114.63,293.29Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.53,287.51c-8.5-1.41-13.57,17.83-2.76,19.39C130,308.37,132.67,289.19,122.53,287.51Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.53,287.51c-8.5-1.41-13.57,17.83-2.76,19.39C130,308.37,132.67,289.19,122.53,287.51Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.4,366.87a6.13,6.13,0,0,1-3-4c-.56-4.11-.77-22,0-33.81.67-10.34.93-12.86,3.41-13.94v-1c-3.5,1.3-3.71,4.33-4.4,14.92-.8,12.24-.56,29.85,0,34,.32,2.29,2.15,3.94,3.92,5C130.36,367.65,130.38,367.26,130.4,366.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.23,310.54c0,.34-.11.69-.17,1,5.51,3.34,5.25,6.28,4.48,14.27-.09,1-.19,2-.29,3.12A329.46,329.46,0,0,1,108,363.54a1.69,1.69,0,0,1-1,1.2c-1.33.59-3.68.11-6.06-.7,0,.34-.1.68-.14,1a15.7,15.7,0,0,0,4.72.95,4.57,4.57,0,0,0,1.88-.34,2.65,2.65,0,0,0,1.57-1.88,332.18,332.18,0,0,0,5.29-34.71c.1-1.11.19-2.14.29-3.1C115.32,317.75,115.64,314.3,109.23,310.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.58,179.3c-7.26-2.37-14.65-11.21-14.65-11.21s10.48-17.92,19.54-11.25S172.83,183.62,159.58,179.3Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.58,179.3c-7.26-2.37-14.65-11.21-14.65-11.21s10.48-17.92,19.54-11.25S172.83,183.62,159.58,179.3Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.3,166.32c1.78,11.6-.42,24.05-2.7,31.12-.95,3.37-8.93,5.57-18.22,5.57s-16.23-3.35-17.37-6.58,3.53-10.21-3.7-32.78c0,0,10.93-17,26.09-13.33S164.3,166.32,164.3,166.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.49,113.71c-15.35.66-28.06,5.87-31.51,12.6s-1.29,20.46,3.17,30.83c3.07,7.13,9,20.2,14.28,23.67s13.4,3.89,17.53-2.94,10.84-22.11,18.39-15c6.83,6.42,6.16,13.39,4.73,15.06A5.4,5.4,0,0,1,164.9,179l-.07,1.56a7.22,7.22,0,0,0,4.14-2.4c4.56-4.87,6.14-20.92,4.18-37.65S164.68,112.63,139.49,113.71Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.86,126.51c3.67-3.91,9.46-1.26,12.43,3.71,3.66,6.16,4.78,15.94,1.45,21s-10,3-13.39-2.79C107.28,141.56,107.76,129.82,110.86,126.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.82,148.33a17.36,17.36,0,0,0-5.94-2.43,38.72,38.72,0,0,0-9.49-.8c-1.24-11.83-4.79-20.67-8.08-23.55l-.66.75c2.69,2.35,6.49,10.68,7.79,22.84-10,.44-21,3.63-26.68,7.46a33.65,33.65,0,0,0-7.47,6.81,91,91,0,0,1-2.14-9.68l-1,.16a92.09,92.09,0,0,0,2.37,10.51,21.34,21.34,0,0,0-4.21,11.44c.33.57.66,1.13,1,1.68a19.82,19.82,0,0,1,3.57-11.88c2.16,7.26,5.78,16.13,11.44,21.58a11.27,11.27,0,0,0,1.3-.17c-6.06-5.4-9.84-14.9-12-22.43a31.63,31.63,0,0,1,7.7-7.19c5.54-3.77,16.39-6.9,26.22-7.32a86.08,86.08,0,0,1,.05,14.93,4.85,4.85,0,0,1,1,.15,88.17,88.17,0,0,0-.08-15.11,37.68,37.68,0,0,1,9.17.79,15.52,15.52,0,0,1,6.22,2.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.19,193.37a18.11,18.11,0,0,1-2.89-.25c-10.89-1.85-22.11-13.46-28.4-22.84a6.46,6.46,0,0,1,10.72-7.2C75.48,173.3,84,179.62,88.46,180.39a2.4,2.4,0,0,0,1.37-.06c2.1-1.59,7-12,11.76-34.3,3-13.8,4.33-20.1,12.75-21.3A6.46,6.46,0,0,1,117,137.34a112.42,112.42,0,0,0-2.79,11.4c-7.55,35.09-14.39,40.22-16.63,41.91A13.7,13.7,0,0,1,89.19,193.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.37,150.61a2,2,0,0,1-1.84-1.25l-.18-.44a34.35,34.35,0,0,1-2-6.15,13.92,13.92,0,0,1,.59-8.61,2,2,0,0,1,3.6,1.7,9.69,9.69,0,0,0-.31,6.07,30.52,30.52,0,0,0,1.82,5.5l.18.45a2,2,0,0,1-1.1,2.58A1.92,1.92,0,0,1,58.37,150.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66,153.66a2,2,0,0,1-1.63-3.11c.76-1.11,1.59-3-.05-6.64A2,2,0,1,1,68,142.28c1.82,4,1.71,7.58-.31,10.52A2,2,0,0,1,66,153.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.95,
    cy: 158.72,
    r: 11.08,
    transform: "translate(-72.18 51.6) rotate(-30.38)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.45,152.44a1.94,1.94,0,0,1-1.2-.41,18.34,18.34,0,0,1-4.65-5.66A12.92,12.92,0,0,1,44.73,138a2,2,0,0,1,3.93.58,9,9,0,0,0,1.38,5.8,14.94,14.94,0,0,0,3.62,4.5,2,2,0,0,1-1.21,3.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.14,159.73a1.87,1.87,0,0,1-.62-.1,17.7,17.7,0,0,1-6.61-3.44,16.86,16.86,0,0,1-4.63-6.54,2,2,0,1,1,3.63-1.59,13.08,13.08,0,0,0,3.52,5.06,14.05,14.05,0,0,0,5.32,2.74,2,2,0,0,1-.61,3.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.75,81.89a28.84,28.84,0,0,0,4.62,13.58c2.52,3.77,4.79,7,4.79,10.92v10s7,9.92,17,8.23c10.41-1.74.13-8.94.13-8.94V107s1.25-10.81-5.57-17.71S122.75,81.89,122.75,81.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.7,85.07c-1.47-8.09,1-16.59,10.64-22.74s30.74-1.66,33.14,13.44c2.1,13.1.78,20-1.21,27.18-1.23,4.47-3.77,8.17-7.94,8.38-4,.2-10.4-.23-15.13-2.24-1.91-.81-3.53-2.3-5.11-7.63C135.11,94.79,132.79,85.6,122.7,85.07Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.06,82.69c-6.1-.76-5.14,1.89-4,5.73,1.17,4,4.6,7.58,14.11,7.87,6.32.2,10.9-.91,14.12-3.15a58.92,58.92,0,0,0-.16-12.79A18.45,18.45,0,0,1,160,82.79,61.32,61.32,0,0,1,143.06,82.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.69,77.14c-.07-.46-.13-.9-.21-1.37a.3.3,0,0,0,0-.1,6,6,0,0,1-3.89,2.82c-1.42-6.66-4.16-11.8-8.2-15.32a19.81,19.81,0,0,0-4-2.72,28.42,28.42,0,0,0-5.54-.77,20.61,20.61,0,0,0-9.61,5.13,18.42,18.42,0,0,0-1.36,1.45,24.35,24.35,0,0,0-6.38,1c-.41.46-.79.92-1.14,1.39a24.23,24.23,0,0,1,6.74-1.37c-4.82,6.36-5.44,14.59-5.38,19a10.53,10.53,0,0,1,1,.53c-.12-4.25.35-13.1,5.65-19.56a23.44,23.44,0,0,1,6.7,1.08c7.15,2.22,8.67,5.1,10.27,8.16l.38.71c1.21,2.27,3.9,2.95,6.48,2.95a17,17,0,0,0,3.61-.41,53.78,53.78,0,0,1,.88,8.63c.39,13.88-2.53,19.6-5,22a7.11,7.11,0,0,1-1.49,1.07l1.2,0c.24,0,.46,0,.68-.07s.16-.12.24-.2c2.69-2.48,5.82-8.43,5.42-22.74a55.3,55.3,0,0,0-.92-8.85A7.82,7.82,0,0,0,166.69,77.14Zm-14.12-.43L152.2,76c-1.7-3.24-3.31-6.3-10.86-8.63a23.83,23.83,0,0,0-6.14-1.09c.24-.25.45-.51.7-.75a20.31,20.31,0,0,1,11.42-5.33,19.41,19.41,0,0,1,6.4,3.72c3.88,3.39,6.52,8.36,7.88,14.82C158.94,79.34,154.12,79.6,152.57,76.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.2,90.93c.9-.06,1.55-2.09,3.38-2.43s2.81,2.09,3.69,2-.29-4.23-3.72-4C150.59,86.64,149.47,91,150.2,90.93Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,89c.79-.11,1.25-1.94,2.85-2.35s2.61,1.69,3.38,1.57-.5-3.71-3.53-3.35C164.11,85.15,163.36,89.06,164,89Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-349"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.91,113.48a85.7,85.7,0,0,0,18.56-16c9.21-10.75,13.93-22.71,14.13-34.66v71c-.3,18.35-11.22,36.67-32.69,50.67-13.23,8.63-29,14.64-45.69,18v-71C210.94,128.13,226.68,122.11,239.91,113.48Z",
    style: {
      fill: "#455a64",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.91,113.48a85.7,85.7,0,0,0,18.56-16c9.21-10.75,13.93-22.71,14.13-34.66v71c-.3,18.35-11.22,36.67-32.69,50.67-13.23,8.63-29,14.64-45.69,18v-71C210.94,128.13,226.68,122.11,239.91,113.48Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "1.0238900000000002px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--screen--inject-349"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.35000000000000003
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.24,98.45v91.47c35,16.17,86.6,17.3,119.86,10.63,20.57-4.12,37.61-11.68,53-20.56A104.86,104.86,0,0,0,211,172.78V81.35a109.75,109.75,0,0,1-10.92,7.17c-15.41,8.92-33.74,15.08-53.18,18.56C121,111.76,62.84,111.39,27.24,98.45Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.24,98.45v91.47c35,16.17,86.6,17.3,119.86,10.63,20.57-4.12,37.61-11.68,53-20.56A104.86,104.86,0,0,0,211,172.78V81.35a109.75,109.75,0,0,1-10.92,7.17c-15.41,8.92-33.74,15.08-53.18,18.56C121,111.76,62.84,111.39,27.24,98.45Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "1.0238900000000002px",
      opacity: 0.4
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-349"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-349"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M365.21,115.83c-11.25,0-14.64,3.94-19.12,10.35s-19.75,30.68-19.75,30.68l-21.61,8.31,2.84,12.61s18.3-3.65,27.65-5.57a8,8,0,0,0,5.88-4c1.2-1.83,13.22-20.74,13.22-20.74Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.61 145.39 332.07 159.66 343.2 207.8 342.3 208.77 303.84 194.4 290.71 146.35 291.61 145.39",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.16 160.63 342.3 208.77 343.2 207.8 332.07 159.66 331.16 160.63",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.71 146.35 331.16 160.63 342.3 208.77 303.84 194.4 290.71 146.35",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M309.85,184.62c-.37.94-3.47,3-8,2.65l-.76-2.78Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M302.89,156.21s-.15-.72-.33-1.61,2.19-.42,5.3,1l7.31,2.22c3.11,1.46,6.05,2.56,6.23,3.45l.34,1.61Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M300.49,148.91c-.12-.56.81-.44,2.1-.1l2.33.8s-.95-2.34,4.56-.85c6.07,1.64,6.2,4.67,6.2,4.67a26.17,26.17,0,0,0,2.91,1.06c2,.66,2.24,1,2.41,1.62l.29,1-20.62-7.26S300.61,149.47,300.49,148.91Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.66,152c1.91.86,2.7,1.29,3,2.66.32,1.57.39,2.22.39,2.22l10.74,4.24s-.58-2.31-.73-3.08,1.28-.78,3.14.08l-.44-1.92L302.05,150Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.34,156.24s-.15-.72-.33-1.61,2.19-.43,5.3,1l7.3,2.21c3.11,1.47,6.06,2.57,6.24,3.46l.33,1.61Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.21,162.82s1.43,5.28,1.81,6.62,7,4.39,10.32,4.8c6.34.79,7.06,2.17,5.53,6.68-1.4,4.15-5.53,5.72-11.26,5a10.38,10.38,0,0,1-7.86-6.86c-1.85-5.31-.85-11-1.59-14.07S293.59,161,295.21,162.82Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.14 377.64 396 377.64 393.57 356.13 408.14 356.13 408.14 377.64",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.38 356.84 354.43 357.35 354.52 335.08 369.16 334.7 367.38 356.84",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.57,203.52c.23,11.79,2.73,89.82,2.73,89.82a172.88,172.88,0,0,1,1.55,19.23c.32,15.59-2.94,52.59-2.94,52.59-.72,3.37-13.29,4.74-15,1.7,0,0-6.86-53.68-8.81-69.11-1.7-13.47-7.3-57.5-7.3-57.5l-4.34,43.23a134,134,0,0,1-.34,15.16c-.51,7.13-4.09,49.24-4.09,49.24-.06,2.62-13.12,4.8-15.33.93,0,0-4.13-61.47-4.25-68-.15-7.47.89-78.12.89-78.12Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.3,371.46l-.21-1.83c-.67,0-1,.76-1.24,2.37a34.85,34.85,0,0,1-3.22,9.9c-2.06,4.25-3.26,6-7.33,11.12-1,1.21-3.14,3.14-3.9,4.49s-1,5.12.26,6c4.75,3.16,11.95,3.25,17,1.75a9.77,9.77,0,0,0,7.4-8.31c.83-4.64,1.26-7.51,3.63-11,.86-1.28,2.26-2.32,2.85-3.76,1.06-2.58.21-5.48-.46-8-.59-2.22-1.22-4.67-2-4.46V371c-.91,1-4.1,2-6.95,2.12C399.35,373.2,395.28,372.87,395.3,371.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.45,353.84c-.32.21-1.05,1.06-2.34,2.28a47.2,47.2,0,0,1-4.18,3.26,78,78,0,0,1-9.28,5.91c-3.84,2.14-7.3,3.45-11.89,5.56a3.74,3.74,0,0,0-1.29.86,2.67,2.67,0,0,0-.55,1.15,4.76,4.76,0,0,0,2,4.59,12.55,12.55,0,0,0,4.82,2,24.63,24.63,0,0,0,12,.29,33.81,33.81,0,0,0,9.61-4.52,21.65,21.65,0,0,1,8.23-3.59c2.58-.39,5.76-.29,8-1.84,2.48-1.74,1.46-5.4.74-8.54-.79-3.44-1-8.69-2.56-8.56l-.11,1.37c-.13,1.49-3.72,2.19-6.51,2.21-2.3,0-6.67-.56-6.66-1.64C354.43,354.64,354.45,353.85,354.45,353.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.5,223.73a39.37,39.37,0,0,1-13.25-8.51s2.11,6.18,10.79,11.26l-.57,53.84,4.37-40.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.14,115.17c2.2.52,9.05,1.45,14.72,3.45A15.85,15.85,0,0,1,410,124.1c4.12,6,.4,19.39-2.63,44.59.23,16.27.7,36.49.7,36.49-7.48,5.45-42.37,9.15-58.12-2.34,0,0,.79-47.39,2.53-59.32,2.21-15.16,9.71-27.72,18.27-28.66Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.31,79.14a15.9,15.9,0,1,1-15.52-16.28A15.9,15.9,0,0,1,384.31,79.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.62,90.72s-2.86,12-3.94,14a5.51,5.51,0,0,1-3.23,2.48l.38-8.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.8,73.3a6,6,0,0,1,4.9,1.85c2.07,2.22.72,9-2.08,15.57l-4.86.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.3,91.13c1,.6,2.39-1.24,3.62-2.46S398.11,85.82,400,90s-2,9.7-5.07,10.6c-5.35,1.54-6.07-1.89-6.07-1.89l-.91,21.7h0c-3.79,4.62-12.71,4.88-17.14,4-3.53-.72-3.58-3.22-.1-7.07l.16-6.21a33.58,33.58,0,0,1-7.17.19c-3.89-.7-6.29-3.83-7.36-8.1-1.64-6.5-2-13.77-.4-25.67,2-14.62,19.16-14.35,28.22-8.34S389.3,91.13,389.3,91.13Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.26,92.76c.49,0,2.43-3,3.66-4.09,1.72-1.49-.12-15.37-.12-15.37a6.71,6.71,0,0,0-1-7.49c-2.24-2.59-5.38-5.75-15.84-4.77-7.45.7-15.6,2.83-22.07-.54a11.13,11.13,0,0,0,3.6,11.91s2.33,1.59,8.54,2.49,15.92.24,17.25.09c1.81-.2,2.16,1.55,3,6.36C387.08,85.56,387.62,92.69,389.26,92.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.77,74.38l6-3a3.25,3.25,0,0,0-4.42-1.58A3.5,3.5,0,0,0,392.77,74.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.84,111.1s8.77-1.55,11.86-3.1a10,10,0,0,0,4.31-4.07,13.72,13.72,0,0,1-2.51,4.86c-2.3,2.8-13.72,4.8-13.72,4.8Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.78,89a1.75,1.75,0,1,0,1.66-1.91A1.78,1.78,0,0,0,373.78,89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.91,82.41l3.84,1.87a2.24,2.24,0,0,0-1-2.93A2.09,2.09,0,0,0,374.91,82.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.66,100.17l-6.34,1.74a3.23,3.23,0,0,0,4,2.41A3.44,3.44,0,0,0,373.66,100.17Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.66,101.79a2.44,2.44,0,0,0-3.67,2.14,2.42,2.42,0,0,0,.05.47,3,3,0,0,0,1.26-.08A3.35,3.35,0,0,0,373.66,101.79Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.81,84l4.08-1.39a2.07,2.07,0,0,0-2.67-1.38A2.27,2.27,0,0,0,356.81,84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.38,88.28a1.75,1.75,0,1,0,1.91-1.65A1.79,1.79,0,0,0,358.38,88.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.27 87.51 367.64 98.02 362.16 96.12 368.27 87.51",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.17,114.46l-.17,4.06s-3.95,17.19-5.1,26.2c-1.6,12.56-1.29,48-.44,70.5.62,16.38,3.07,46.67,3.07,46.67s4,.82,13.81-.8c8.31-1.37,12.52-3.83,14.3-4.9,0,0-1.54-46.05-2.71-62.13-1.07-14.83-1-23-1-23l3.5-33.84S413,118.87,404.71,117A116.07,116.07,0,0,0,388.17,114.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.8,226.51c1.69-2.87,1.78-5,4.32-7.58a8.52,8.52,0,0,0,2.3-3.83c.79-2.3.74-4.7.93-7.21l14.76.68a93.62,93.62,0,0,1-1.82,16.34c-2.8,12.33-5.51,17.52-10.81,18.71-8.46,1.91-10.54-1.73-7.57-7.84a30.09,30.09,0,0,0,2.71-8.05,15,15,0,0,1-3.15,2.82,3,3,0,0,1-4-.44C406.09,229.58,407.48,228.77,408.8,226.51Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.71,117s8,.38,12.4,4.34,6.74,14.57,9.6,25.2,5.37,21,6.13,28.36c.63,6.18-1.43,38.68-1.43,38.68s-9,1.89-15.89-1.89l-.29-36.13-11.41-36.2A35.1,35.1,0,0,1,404.71,117Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.78,114.46a46.38,46.38,0,0,0-8.14,1.44c-2.85.92-4.51,3.26-6.38,7.27-2.73,5.88-5.3,11.9-6.79,39.21-1.43,26.28-2.34,94.23-2.34,94.23a20.22,20.22,0,0,0,8.87,1.8s.65-81.59,1.66-100.16c1.14-21.19,4.63-31.8,8.66-37.92,1.95-3.21,3.71-4.44,4.46-4.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.68,94.49a6.56,6.56,0,0,0,4.81,2.11h.67c2.89,0,4.27-1.74,5.44-4.45.33-.78,1-2.08,1.9-2.08s1.57,1.3,1.91,2.08a7.3,7.3,0,0,0,6.68,4.43h3.83a6.39,6.39,0,0,0,6.37-7v-.07c-.18-2-.4-4.43-.67-5.86-1-5.16-7.14-6.13-18.13-6.12s-12.88,1-13.87,6.16c-.26,1.39-.47,3.76-.64,5.67v.12A6.53,6.53,0,0,0,352.68,94.49Zm.26-4.81c.16-1.84.36-4.28.61-5.59.61-3.19.16-4.55,11.94-4.56s15.58,1.33,16.2,4.52c.26,1.35.48,3.85.65,5.73a4.45,4.45,0,0,1-4.42,4.83h-3.83a5.31,5.31,0,0,1-4.87-3.26c-.71-1.62-1.88-3.26-3.72-3.26s-3,1.64-3.71,3.27c-.84,2-1.5,3.27-3.63,3.27h-.67A4.56,4.56,0,0,1,352.94,89.68Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.94,89.68a4.56,4.56,0,0,0,4.55,5h.67c2.13,0,2.79-1.31,3.63-3.27.71-1.63,1.87-3.26,3.71-3.27s3,1.64,3.72,3.26a5.31,5.31,0,0,0,4.87,3.26h3.83a4.45,4.45,0,0,0,4.42-4.83c-.17-1.88-.39-4.38-.65-5.73-.62-3.19-4.42-4.54-16.2-4.52s-11.33,1.37-11.94,4.56C353.3,85.4,353.1,87.84,352.94,89.68Z",
    style: {
      fill: "#37474f",
      opacity: 0.71
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoboticsDashboard);
export default __webpack_public_path__ + "static/media/RoboticsDashboard.32db095b1323dd450c65bfa7108e71d1.svg";
export { ForwardRef as ReactComponent };